// extracted by mini-css-extract-plugin
export default {"card-box":"ProjectCard_card-box__sfRfN","card-title":"ProjectCard_card-title__+a06l","card-desc":"ProjectCard_card-desc__Ff-6q","icon":"ProjectCard_icon__uRn8n"};